module.exports = __webpack_public_path__ + "static/default_og_image-810ba2c89453c5ba44671d7df3726c75.jpg";